<div class="my-5">
  <sm-page-header [breadcrumb]="breadcrumb" title="settings.currency.history.title"> </sm-page-header>
  <div class="content">
    <div class="flex mb-4 gap-2">
      <div>
        <p> {{ 'settings.currency.history.filters.date.label' | translate }} </p>
        <p-datepicker
        fluid
        [dateFormat]="dateField.props?.['format'] || 'dd/mm/yy'"
        appendTo="body"
        [view]="dateField.props?.['view'] || 'date'"
        [disabled]="!!(dateField.isDisabled | async)"
        [class.w-full]="true"
        [class.ng-invalid]="!!(dateField.error | async)"
        [class.ng-dirty]="!!(dateField.error | async)"
        [showIcon]="true"
        [minDate]="dateField.props?.['minDate']"
        [maxDate]="dateField.props?.['lastDate']"
        [showTime]="dateField.props?.['showTime'] || false"
        hourFormat="24"
        [showButtonBar]="true"
        [ngModel]="dateField.props?.['value'] | async"
        (ngModelChange)="dateField.props?.['onChange']($event)">
      </p-datepicker>
      </div>
  </div>
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading" [totalRecords]="totalRecords"></sm-data-table-builder>
  </div>